// @ts-nocheck

export const TIMEOUT_REPLAY_BOOSTED_ODD_ANIMATION = 4000;
export const TIMEOUT_START_BOOSTED_ODD_ANIMATION = 1000;

// `18` refers to 9px + 9px (left padding + right padding on mobile)
export const MOBILE_BOOSTED_ODD_PADDING = 18; // px
